import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import store from 'store';
import * as authentication from 'actions/authenticationActions';
import * as userTypes from 'actions/userTypesActions';

export default function logoutUser() {
  Auth.configDfd = null;

  store.dispatch(userTypes.setUserAsLead());
  store.dispatch(authentication.logUserOut());

  browserHistory.push('/');
}
